// extracted by mini-css-extract-plugin
module.exports = {"support_text":"WhatsappAssistButton_support_text__3ulCU","label":"WhatsappAssistButton_label__11ZRP"};